import {
  CircularProgress,
  Table as MuiTable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

import type { HeadCell, Row, TableProps } from './types';

type headerProps = {
  headCells?: (HeadCell | undefined)[];
};
type rowProps = {
  rows?: Row[];
};

const EnhancedTableRow = (props: rowProps) => {
  const { rows } = props;

  return (
    <TableBody>
      {rows?.map((row, index) => {
        const { cells, onClick, hover, sx } = row;

        return (
          <TableRow key={index} onClick={onClick} hover={hover} sx={sx}>
            {cells.map((cell) => {
              const { name, value, formatting, align, component, hidden, onClick, sx } = cell;
              const cellValue = formatting ? formatting(value) : value;

              if (hidden) {
                return;
              }

              if (component) {
                return (
                  <TableCell
                    key={name}
                    align={align ?? 'left'}
                    height={53}
                    onClick={onClick}
                    sx={sx}
                  >
                    {component}
                  </TableCell>
                );
              }

              return (
                <TableCell key={name} align={align ?? 'left'} height={53} onClick={onClick} sx={sx}>
                  {cellValue}
                </TableCell>
              );
            })}
          </TableRow>
        );
      })}
    </TableBody>
  );
};

const EnhancedTableHead = (props: headerProps) => {
  const { headCells } = props;

  return (
    <>
      <TableHead>
        <TableRow>
          {headCells?.map((headCell) => {
            if (!headCell) {
              return null;
            }
            if (headCell.hidden) {
              return null;
            }
            return (
              <TableCell
                key={headCell.id}
                align={headCell.align}
                padding={headCell.disablePadding ? 'none' : 'normal'}
              >
                {headCell.label}
              </TableCell>
            );
          })}
        </TableRow>
      </TableHead>
    </>
  );
};

export const Table = (props: TableProps) => {
  const { headCells, rows, isLoading } = props;

  return (
    <TableContainer>
      <MuiTable size="small">
        <EnhancedTableHead headCells={headCells} />
        {isLoading ? (
          <TableBody>
            <TableRow>
              <TableCell colSpan={headCells?.length} sx={{ textAlign: 'center' }}>
                <CircularProgress />
              </TableCell>
            </TableRow>
          </TableBody>
        ) : (
          <EnhancedTableRow rows={rows} />
        )}
      </MuiTable>
    </TableContainer>
  );
};
